<template>
  <div class="mianDiv">
    <MessageSuccess :msg="msg"></MessageSuccess>
  </div>
</template>
<script>
import MessageSuccess from "../../components/tips/messageSuccess";
export default {
  data() {
    return {
      msg: "机器人已经执行完成，共发送了23位客户"
    };
  },
  components: {
    MessageSuccess
  },
  methods: {},
  created() {
    const id = this.$route.params.id || "";
    this.$common
      .http({
        url: "index.php",
        data: {
          data: JSON.stringify({
            id
          })
        }
      })
      .then(res => {
        this.msg = "机器人已经执行完成，共发送了" + res.num + "位客户";
      });
  }
};
</script>
<style lang="less" scoped></style>
